import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";


export const GetOPDDiagnosisDetailById = (params: any) =>
    GET_ENC(`${BASE_URL}/api/OPDDiagnosis/GetDetail?` + params, null);

export const CreateOPDDiagnosis = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDDiagnosis/Create`, data);

export const UpdateOPDDiagnosis = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDDiagnosis/Update`, data);

export const DeleteOPDDiagnosisDetail = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDDiagnosis/Delete`, data);

export const UpdateOPDDiagnosisTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/OPDDiagnosis/UpdateByTemplate`, data);